var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNivel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 16,
    viewBox: "0 0 109 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292885 7.29289C-0.097641 7.68342 -0.097641 8.31658 0.292885 8.70711L6.65685 15.0711C7.04737 15.4616 7.68053 15.4616 8.07106 15.0711C8.46159 14.6805 8.46159 14.0474 8.07106 13.6569L2.41421 8L8.07106 2.34315C8.46159 1.95262 8.46159 1.31946 8.07106 0.928932C7.68053 0.538408 7.04737 0.538408 6.65685 0.928932L0.292885 7.29289ZM109 7L0.999992 7V9L109 9V7Z",
    fill: "#094F9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNivel);
export default __webpack_public_path__ + "static/media/ArrowNivel.8965559a35364b288011527e98a065cd.svg";
export { ForwardRef as ReactComponent };